export const th = {
    //#region common
    default: {
        search: 'ค้นหา',
        confirm: 'ยืนยัน',
        register: 'สมัครสมาชิก',
        continue: 'ต่อไป',
        day: 'วัน',
        month: 'เดือน',
        year: 'ปี',
        birthdate: 'วัน/เดือน/ปี เกิด',
        nointerner_1: 'ไม่สามารถเชื่อมต่ออินเทอร์เน็ตได้',
        nointerner_2: 'กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ตของคุณแล้วลองใหม่อีกครั้ง'
    },
    date: {
        days: 'วัน',
        months: 'เดือน',
        years: 'ปี',
        minutes: 'นาที',
        minutes_short: 'น.',
        minutes_short2: 'นาที',
        hours: 'ชั่วโมง',
        hours_short: 'ช.ม.',
        date_flase: 'กรุณาระบุวันเกิด',
        month_full: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
        month_short: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
        month_full_arr: [{ strvalue: "01", strtext: 'มกราคม' },
        { strvalue: '02', strtext: 'กุมภาพันธ์' },
        { strvalue: '03', strtext: 'มีนาคม' },
        { strvalue: '04', strtext: 'เมษายน' },
        { strvalue: '05', strtext: 'พฤษภาคม' },
        { strvalue: '06', strtext: 'มิถุนายน' },
        { strvalue: '07', strtext: 'กรกฎาคม' },
        { strvalue: '08', strtext: 'สิงหาคม' },
        { strvalue: '09', strtext: 'กันยายน' },
        { strvalue: '10', strtext: 'ตุลาคม' },
        { strvalue: '11', strtext: 'พฤศจิกายน' },
        { strvalue: '12', strtext: 'ธันวาคม' }]
    },
    confirm_redeem: {
        confirm: "ยืนยันการยกเลิก",
        cancel: "ไม่ตอนนี้",

        confirm2: "ยืนยัน",
        cancel2: "ยกเลิก",

        default1: "คุณต้องการใช้",
        default2: "คะแนนเพื่อแลกของขวัญชิ้นนี้",


        headline: 'จุดรับของขวัญ',
        headline2: 'กรุณาเลือกสาขาที่คุณต้องการรับของขวัญ',
        free: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        free_no_timer: 'ยืนยันการรับสิทธิ์',
        free_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        draw: 'ยืนยันเพื่อเข้าร่วมสนุก <br/> ประกาศผู้ชนะหลังวันที่ {0}',
        draw_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        deal: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        deal_no_timer: 'ยืนยันการรับสิทธิ์',
        deal_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        buy: 'ยืนยันการซื้อ',
        buy_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        interface: 'ยืนยันเพื่อเข้าสู่เว็บไซต์ที่ร่วมรายการ',
        reward_confirm: 'ยืนยันการจองเข้าร่วมงาน',
        freegift_confirm: "ข้อมูลการจองของขวัญ",
        freegift_confirm_message: 'Do you want to confirm redeem',
        pleasefill: 'กรุณากรอกข้อมูลให้ถูกต้อง',
        continue: 'ต่อไป',
        province: 'จังหวัด',
        district: 'อำเภอ/เขต',
        brance: 'สาขา',

        headline_store: 'กรุณาเลือกวันที่และเวลา',
        headline_store2: 'Please choose the store </br> to pick up your product.',
        store: 'สาขา',
        date: 'วันที่',
        datetime:'เวลา',
        book: 'นัดหมาย',
        news_from: 'ท่านได้รับข่าวสารจากช่องทางไหน',
        select_one: 'โปรดเลือก',
        answer_one: 'โปรดระบุรายละเอียด (เช่น ปันโปร เซ็นทรัล)',
        question_mark: '',
        bcs: 'พนักงานที่ปรึกษาความงาม',
        select_store: 'รายละเอียดการนัดหมาย',
        please_choose: 'กรุณาเลือกสาขา </br> ที่คุณต้องการเข้ารับบริการ',
        not_time: 'ไม่มีช่วงเวลาที่ให้บริการ',

        select_freegift_store: "กรุณาเลือกสาขา </br> ที่คุณต้องการรับของขวัญ",
        select_placeholder: "สาขา",


    },
    redeem_button: {
        default: 'แลกรับของขวัญ',
        default_freegift: 'รับสิทธิ',
        none: '',
        soldOut: 'การสำรองเวลาเต็มแล้ว',
        soldOut_freegift: 'สิทธิถูกใช้ครบแล้ว',
        soldOutBuy: 'ขออภัย ไม่สามารถทำการแลกของขวัญชิ้นนี้ได้',
        maxPerPerson: 'ขออภัย คุณได้แลกของขวัญชิ้นนี้แล้ว',
        maxPerPerson_freegift: 'แคมเปญหมดอายุแล้ว',
        redeemCoolDown: 'คุณได้รับสิทธิ์นี้แล้ว',
        nextDate: 'รับสิทธิ์ครั้งต่อไปได้<br/>ตั้งแต่ : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'คุณต้องทำตามเงื่อนไขที่ระบุไว้ใน Campaign นี้ก่อนจึงสามารถกดรับได้ กรุณาอ่านเพิ่มเติมในรายละเอียด',
        campaignExpired: 'แคมเปญหมดอายุแล้ว',
        campaignExpiredBuy: 'สินค้านี้หมดอายุแล้ว',
        campaignNotAvailable: 'สิทธิพิเศษนี้ไม่สามารถรับได้ในตอนนี้',
        campaignNotAvailableBuy: 'สินค้านี้ไม่สามารถรับได้ในตอนนี้',
        notEnoughPoint: 'คะแนนของคุณไม่เพียงพอสำหรับการเเลกของขวัญชิ้นนี้',
        notSupport: 'ไม่รองรับแคมเปญประเภทนี้',
        soldOutBooking: 'ช่วงเวลาที่เลือกเต็มแล้ว',
        alreadyRedeem: 'คุณได้ทำการจองเข้าร่วมงานนี้แล้ว',
        longerEligible: 'ไม่สามารถเลือกเวลาที่เคยเลือกไปแล้ว',
        error101: 'ไม่อนุญาตให้จองที่เคาน์เตอร์ที่กำหนด',
        error102: 'พนักงาน หรือ ห้องที่เลือกเต็มแล้ว',
        error103: 'พนักงานไม่ได้รับอนุญาตให้จัดการบริการที่เลือก',
        error104: 'ช่วงเวลาที่เลือกเต็มแล้ว',
        error105: 'คุณได้ทำการจองเข้าร่วมงานนี้แล้ว',
        error108: 'คุณได้ใช้สิทธิ์ครบเต็มจำนวนแล้ว',
        error109: 'ไม่มีบริการที่เคาน์เตอร์ที่เลือกในวันที่เลือก',
        error201: 'การให้บริการนี้เต็มแล้ว',
        error301: 'กรุณาติดต่อ Call Center 02-666-9496',
        error999: 'เกิดข้อผิดพลาดกรุณาลองใหม่ภายหลัง',

        cate:{
            error102: 'ไม่สามารถทำการนัดหมายบริการในเวลาที่เลือกได้',
            error105: 'คุณมีนัดหมายอื่นในเวลาเดียวกัน',
            error106: 'คุณได้ทำการจองบริการนี้แล้ว',
            error108: 'คุณได้ใช้สิทธิ์ครบตามจำนวนแล้ว',
            error202: 'คุณได้ทำการจองบริการนี้แล้ว',
            error301: 'กรุณาติดต่อแผนกลูกค้าสัมพันธ์ที่หมายเลข 02-666-9496 (ในช่วงเวลาทำการ)',
            error999: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
        }
    },
    gift_detail: {
        confirm: "ยืนยัน",
        cancel: "ยกเลิก",

        header: 'จุดรับของขวัญ',
        header2: 'กรุณาเลือกสาขา <br/> ที่คุณต้องการรับของขวัญ',
        province: 'จังหวัด',
        district: 'อำเภอ/เขต',
        brance: 'สาขา',

        pleasefill: 'Please fill information',
        thank_redeem: 'ขอบคุณสำหรับคำยืนยันการแลกของขวัญ',
        thank_redeem_freegift: 'ขอบคุณสำหรับคำยืนยันการแลกของขวัญ',
        close: 'ปิด',
        use_code_now: "แสดงบาร์โค้ด",
        mark_use: "ใช้สิทธิ์",

        confirm_redeem: {
            header: 'ข้อมูลการจองของขวัญ',
            header2: 'Do you want to confirm redeem',
            name: 'Name : ',
            member_id:'Member ID : ',
            branch: 'Branch : ',
            gift: 'Gift : ',
            use: 'Use : ',
            accept: 'Accept ',
            condition: 'Conditions ',
            order_no: 'Order No. : ',
        },

        error101: 'รหัสสมาชิกไม่ถูกต้อง',
        error102: 'รหัสสมาชิกถูกระงับ',
        error103: 'ไม่พบรหัสสมาชิกนี้',
        error104: 'ประเภทของสมาชิกไม่สามารถจองของรางวัลได้',
        error201: 'ไม่มีรายการการแลกของรางวัล',
        error202: 'คะแนนโบนัสไม่เพียงพอ',
        error203: 'เกินกำหนดเวลาแลกของรางวัล',
        error204: 'รหัสสาขาไม่ถูกต้อง',
        error205: 'ไม่สามารถจัดส่งของรางวัลได้',
        error206: 'ที่อยู่จัดส่งไม่สมบูรณ์',
        error207: 'อีเมลไม่ถูกต้องสำหรับการแจ้งเตือน',
        error208: 'ตรวจสอบการจองของรางวัล',
        error300: 'รายการของรางวัลเกิดข้อผิดพลาด',
        error999: 'เกิดข้อผิดพลาดอื่นๆ',
        error301: 'รหัสของรางวัลไม่ถูกต้อง',
        error302: 'ของรางวัลนี้ไม่มีในสต็อก',
        error303: 'คะแนนโบนัสการแลกของรางวัลติดลบ',
        error304: 'เกินระยะเวลาในการจองของรางวัลภายใต้อายุสมาชิก',
        error305: 'ประเภทของรางวัลไม่ถูกต้อง',
        error306: 'ช่องทางการแลกของรางวัลไม่ถูกต้อง',
        error307: 'ของรางวัลนี้ไม่สามารถใช้ได้กับสมาชิกประเภทนี้',
    },
    purchase: {
        show_code: 'กดเพื่อดูรหัส',
        cancel_book: 'ยกเลิกการนัดหมาย',
        canceled_book: 'Cancelled',
        code_expired: 'หมดอายุ',

        delivery: 'สินค้าจะถูกจัดส่งตามเงื่อนไขของแคมเปญ',
        shipped: 'สินค้าได้ถูกจัดส่งเรียบร้อยแล้ว',
        parcel_no: 'พัสดุเลขที่',

        not_draw1: 'รางวัลนี้ยังไม่ได้ประกาศรายชื่อผู้โชคดี',
        not_draw2: 'กรุณากลับมาตรวจสอบใหม่ภายหลัง',
        draw_winner1: 'ขอแสดงความยินดีด้วยค่ะ',
        draw_winner2: 'คุณเป็นผู้โชคดีได้รับของรางวัล',
        draw_not_win1: 'ขออภัย คุณไม่ใช่ผู้โชคดีได้รับของรางวัลนี้',
        draw_not_win2: 'กรุณาร่วมสนุกกันใหม่ในครั้งหน้า',
        Used: "ถูกใช้แล้ว",
    },
    serial: {
        close_btn: 'ปิด',
        show_code_at_shop: 'กรุณาแสดงรหัสนี้ ให้แก่ร้านค้า',

        delivery: 'สินค้าจะถูกจัดส่งตามเงื่อนไขของแคมเปญ',

        draw: 'ขอบคุณที่ร่วมสนุกกับเรา<br/>กรุณาติดตามประกาศผล หลังจากวันที่ {0}',
        draw_after: 'หลังจากวันที่',

        qr_code: 'QR Code',
        barcode: 'Barcode',
        code: 'Code',

        expire_in: 'หมดเวลาใน ',
        code_expired: 'รหัสหมดอายุ',

        redeem_on: 'รับสิทธิ์เมื่อ {0}',
        headBooking: 'กรุณาแสดงหน้าจอนี้เพื่อรับบริการที่ทำการนัดหมายไว้',
        show_code_freegift: 'กรุณาแสดงข้อมูลให้พนักงานขายที่เคาน์เตอร์ดิออร์',

        show_code: 'กรุณาแสดงข้อมูลให้พนักงานขายที่เคาน์เตอร์ดิออร์',
        order_no: 'Order No. : ',
        name: 'Name : ',
        member_id: 'Member ID : ',
        branch: 'Branch : ',
        Use: 'Use : ',
        Used: "ถูกใช้แล้ว",
    },
    //#endregion common

    //#region shipping
    shipping: {
        headline: 'ที่อยู่จัดส่ง',

        firstname: {
            name: 'ชื่อ',
            placeholder: 'ชื่อ',
            required: 'กรุณากรอกชื่อ',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'นามสกุล',
            placeholder: 'นามสกุล',
            required: 'กรุณากรอกนามสกุล',
            too_short: '',
            invalid: '',
        },
        address:  {
            name: 'ที่อยู่',
            placeholder: 'กรุณากรอกที่อยู่',
            required: 'กรุณากรอกที่อยู่',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'เบอร์โทรศัพท์',
            placeholder: 'เบอร์โทรศัพท์',
            required: 'กรุณากรอกเบอร์โทรศัพท์',
            too_short: 'เบอร์โทรศัพท์ต้องมี {0} หลัก',
            invalid: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
        },
        nationalid: {
            name: 'เลขประจำตัวประชาชน',
            placeholder: 'เลขประจำตัวประชาชน',
            required: 'กรุณากรอกเลขประจำตัวประชาชน',
            too_short: 'เลขประจำตัวประชาชนต้องมี {0} หลัก',
            invalid: 'เลขประจำตัวประชาชนไม่ถูกต้อง',
        },
        email: {
            name: 'อีเมล',
            placeholder: 'อีเมล',
            required: 'กรุณากรอกอีเมล',
            too_short: '',
            invalid: 'อีเมลไม่ถูกต้อง',
        },
        zipcode: {
            name: 'รหัสไปรษณีย์',
            placeholder: 'รหัสไปรษณีย์',
            required: 'กรุณากรอกรหัสไปรษณีย์',
            too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
            invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
        },
        subdistrict: {
            name: 'ตำบล/แขวง',
            placeholder: 'ตำบล/แขวง',
            required: 'กรุณาเลือกตำบล/แขวง',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'อำเภอ/เขต',
            placeholder: 'อำเภอ/เขต',
            required: 'กรุณาเลือกอำเภอ/เขต',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'จังหวัด',
            placeholder: 'จังหวัด',
            required: 'กรุณาเลือกจังหวัด',
            too_short: '',
            invalid: '',
        },

        save_address: 'บันทึกที่อยู่เพื่อใช้รับสิทธิ์ครั้งต่อไป',
        save_address_buy: 'บันทึกที่อยู่เพื่อใช้ในการสั่งซื้อครั้งต่อไป',

        confirm_btn: 'ยืนยัน',
        cancel_btn: 'ยกเลิก',

        alert_headline: 'ที่อยู่จัดส่ง',
        alert_ok_btn: 'ตกลง',

        thank_header: 'การจองของขวัญเสร็จสมบูรณ์',
        text_thank: 'คุณจะได้รับการติดต่อทันทีที่ของขวัญพร้อมสำหรับคุณที่เคาน์เตอร์เครื่องสำอางดิออร์สาขาที่คุณเลือก',
        close: 'ปิด'
    },
    //#endregion shipping

    //#region page
    main: {
        home_page: "หน้าแรก",
        login: "เข้าสู่ระบบ",
        campaign: "แคมเปญ",
        category: 'หมวดหมู่',
        map: "แผนที่",
        history: 'ประวัติรับสิทธิ์',
        profile: "โปรไฟล์",
        logout: "ออกจากระบบ",
        lang: "ภาษา",
        msgLogout: "ต้องการออกจากระบบ",
        cancel: "ยกเลิก",
        makeup: "MAKEUP",
    },
    campaign: {
        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้ : ',
    },
    detail: {
        detail: 'รายละเอียด',
        condition: 'เงื่อนไข',
        free: 'ไม่มีค่าบริการ',

        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้ : ',
        available_date: 'แลกได้วันที่',
        booking_now: 'ทำการนัดหมาย',

        color: {
            name: 'สี',
            placeholder: 'กรุณาเลือกสี',
            required: 'กรุณาเลือกสี',
        },
        size: {
            name: 'ขนาด',
            placeholder: 'กรุณาเลือกขนาด',
            required: 'กรุณาเลือกขนาด',
        },
    },
    history: {
        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',

        parcel_number: 'เลขพัสดุ : ',
        date: 'Date : ',
        time: 'Time : ',
        status: 'Status : ',
        brance: 'Branch : ',
        bcs: 'BCs : ',

        gift_status : {
            gc: "Cancelled",
            gd: "In Delivery",
            ge: "Expired",
            gf: "Confirmed",
            gi: "Reserved",
            gr: "Redeemed",
            gt: "Ready to pick",
            go: "Order Processing",
        },
        head_cancel: 'ยกเลิกการแลกของขวัญ',
        head_cancel2: 'Do you want to cancel Reservation',
        title_cancel: 'การแลกรับของขวัญถูกยกเลิกเรียบร้อยแล้ว'
    },
    cancel_booking: {

        header: 'ยกเลิกการแลกของขวัญ',
        head2: 'คุณต้องการยกเลิกการนัดหมายหรือไม่',

        head_cancel: 'ยกเลิกการนัดหมาย',
        head_cancel2: 'การนัดหมายของคุณถูกยกเลิกเรียบร้อยแล้ว',

        booking_no: 'Booking No. : ',
        name: 'Name : ',
        member_id:'Member ID : ',
        date: 'Date : ',
        time: 'Time : ',
        branch: 'Branch',
        bcs: 'BCs : ',
    },
    home: {
        title: 'ลงทะเบียนเพื่อเข้าสู่ทะเบียนสมาชิกของดิออร์',
        enjoy_privilege: 'สิทธิประโยชน์สำหรับสมาชิกดิออร์',
        product_info: 'ข้อมูลผลิตภัณฑ์',
        special_event: 'กิจกรรมพิเศษ',
        gift: 'ของขวัญสำหรับคุณ',
        continue: 'ต่อไป',
    },
    //#endregion page

    //#region register
    register: {
        registeration: 'สมัครสมาชิก',
        birthday: 'วันเกิด',
        phone_number: 'หมายเลขโทรศัพท์',
        or: 'หรือ',
        click_to_scan: 'คลิกเพื่อสแกน QR code จากเคาน์เตอร์เครื่องสำอางดิออร์',
        scan_qr_code: 'สแกน QR code',
        register_term: 'ฉันยอมรับ<u>เงื่อนไขและข้อกำหนดของดิออร์</u>',
        mobile_number_validate: 'การยืนยันหมายเลขโทรศัพท์',
        send_otp_msg: 'ระบบจะส่งรหัส OTP เพื่อยืนยันหมายเลขโทรศัพท์ของคุณ',
        please_enter_otp: 'กรุณากรอกรหัส OTP',
        enter_otp: 'กรอกรหัส OTP',
        refcode: 'รหัสอ้างอิง : ',
        resend_otp: 'ส่งรหัส OTP อีกครั้งใน..',
        form_register_title: 'แบบฟอร์มสมัครสมาชิก',
        register_completed: 'การสมัครสมาชิก<br>สำเร็จ',
        welcome_to_dior: 'ยินดีต้อนรับสู่ดิออร์',
        register_not_complete: 'การสมัครสมาชิก<br> ไม่สำเร็จ',
        try_again: 'กรุณาลองใหม่อีกครั้ง',

        contactnumber: {
            name: 'หมายเลขโทรศัพท์',
            placeholder: 'หมายเลขโทรศัพท์',
            // required: 'กรุณาใส่เบอร์โทร',
            required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            too_short: 'กรุณากรอกหมายเลขโทรศัพท์ 10 หลัก',
            invalid: 'หมายเลขโทรศัพท์ ไม่ถูกต้อง',
        },
        otp: {
            name: '',
            placeholder: 'กรอกรหัส OTP',
            required: 'กรุณากรอกรหัส OTP',
            too_short: 'รหัส OTP ไม่ถูกต้อง',
            invalid: '',
            notcorrect: 'กรุณาลองใหม่อีกครั้ง',
            otpexpire: 'รหัส OTP ของคุณหมดอายุแล้ว'
        },
        firstname: {
            name: 'ชื่อ',
            placeholder: 'ชื่อ',
            required: 'กรุณากรอกชื่อ',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'นามสกุล',
            placeholder: 'นามสกุล',
            required: 'กรุณากรอกนามสกุล',
            too_short: '',
            invalid: '',
        },
        birthdate: {
            required: 'กรุณากรอกปีเกิด',
            invalid: 'กรุณาใส่วันเกิดให้ถูกต้อง',
            pleasefill: 'กรุณากรอกข้อมูลให้ครบถ้วน ',
        },
        email: {
            name: 'อีเมล',
            placeholder: 'อีเมล',
            required: '',
            too_short: '',
            invalid: '',
        },
        address: {
            name: 'ที่อยู่',
            placeholder: 'ที่อยู่',
            required: '',
            too_short: '',
            invalid: '',
        },
        zipcode: {
            name: 'รหัสไปรษณีย์',
            placeholder: 'รหัสไปรษณีย์',
            required: '',
            too_short: '',
            invalid: 'Zip Code invalid',
        },
        province: {
            name: 'จังหวัด',
            placeholder: 'จังหวัด',
            required: '',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'อำเภอ/เขต',
            placeholder: 'อำเภอ/เขต',
            required: '',
            too_short: '',
            invalid: '',
        },
        subDistrict: {
            name: 'ตำบล/แขวง',
            placeholder: 'ตำบล/แขวง',
            required: '',
            too_short: '',
            invalid: '',
        },
        agree:{
            name: "ฉันยอมรับเงื่อนไขและ",
            placeholder: "ฉันยอมรับเงื่อนไขและ",
        },
        term:{
            name: "ข้อกำหนดของดิออร์",
            placeholder: "ข้อกำหนดของดิออร์",
            // required: 'กรุณายอมรับเงื่อนไขและข้อตกลง',
            required: 'ฉันยอมรับเงื่อนไข ข้อกำหนด และนโยบายส่วนบุคคลของดิออร์'
        },

        ms: "นางสาว",
        mrs: "นาง",
        mr: "นาย",
    },
    //#endregion register
    profile: {
        title: 'ข้อมูลสมาชิก',
        edit: 'แก้ไข',
        mycode: 'หมายเลขสมาชิก',
        mypoint: 'คะแนนโบนัส',
        become_member: "Become a member of",
        upgrade_to: "อัพเกรดไประดับ ",
        maintain: "รักษาสถานะ ",
        spent: "ใช้จ่ายเพิ่ม",
        baht: "บาท",
        purchased: "ซื้อเพียง",
        time: "times",
        member_exp: "points and status expiring : ",
        white: "WHITE",
        silver: "SILVER",
        gold: "GOLD",
        platinum: "PLATINUM",
        hight_level: "Highest Status",
        my_status: "MY STATUS",
        and: "และ",
        more_to: "ครั้ง เพื่ออัพเกรดสถานะของคุณ",
        more_to_plat: "ครั้ง เพื่อรักษาสถานะ",
    },
    //#region edit profile
    editprofile: {
        title: 'แก้ไขข้อมูลสมาชิก',
        continue: 'ต่อไป',
        firstname: {
            name: 'ชื่อ',
            placeholder: 'ชื่อ',
            required: 'กรุณากรอกชื่อ',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'นามสกุล',
            placeholder: 'นามสกุล',
            required: 'กรุณากรอกนามสกุล',
            too_short: '',
            invalid: '',
        },
        address:  {
            name: 'ที่อยู่',
            placeholder: 'กรุณากรอกที่อยู่',
            required: 'กรุณากรอกที่อยู่',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'หมายเลขโทรศัพท์',
            placeholder: 'หมายเลขโทรศัพท์',
            required: 'กรุณากรอกหมายเลขโทรศัพท์',
            too_short: 'หมายเลขโทรศัพท์ท์ต้องมี {0} หลัก',
            invalid: 'หมายเลขโทรศัพท์ไม่ถูกต้อง',
        },
        nationalid: {
            name: 'เลขประจำตัวประชาชน',
            placeholder: 'เลขประจำตัวประชาชน',
            required: 'กรุณากรอกเลขประจำตัวประชาชน',
            too_short: 'เลขประจำตัวประชาชนต้องมี {0} หลัก',
            invalid: 'เลขประจำตัวประชาชนไม่ถูกต้อง',
        },
        email: {
            name: 'อีเมล',
            placeholder: 'อีเมล',
            required: 'กรุณากรอกอีเมล',
            too_short: '',
            invalid: 'อีเมลไม่ถูกต้อง',
        },
        zipcode: {
            name: 'รหัสไปรษณีย์',
            placeholder: 'รหัสไปรษณีย์',
            required: 'กรุณากรอกรหัสไปรษณีย์',
            too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
            invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
        },
        subdistrict: {
            name: 'เขต/ตำบล',
            placeholder: 'กรุณาเลือกเขต/ตำบล',
            required: 'กรุณาเลือกเขต/ตำบล',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'แขวง/อำเภอ',
            placeholder: 'กรุณาเลือกแขวง/อำเภอ',
            required: 'กรุณาเลือกแขวง/อำเภอ',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'จังหวัด',
            placeholder: 'กรุณาเลือกจังหวัด',
            required: 'กรุณาเลือกจังหวัด',
            too_short: '',
            invalid: '',
        },
        ms: "นางสาว",
        mrs: "นาง",
        mr: "นาย",
    },
    //#endregion edit profile
    reward: {
        special_event: 'SERVICE LIST',
        redeem_history: 'MY BOOKINGS',
        name: 'ของขวัญพิเศษจากดิออร์',
        point: 'คะแนน',
        expired_date: 'วันหมดอายุ :',
        free_gift_list: 'สิทธิพิเศษ',
        gift_list: 'รายการของขวัญ',
        gift_list_history: 'ประวัติ </br> สิทธิพิเศษ',
        history: 'ประวัติการแลก </br> ของขวัญ'
    },
    location: {
        nearby: 'ในระยะ 10 กม.',
        btnView: 'รายละเอียดเพิ่มเติม',
        address: 'ที่อยู่:',
        operation: 'เวลาทำการ:',
        phone: 'หมายเลขโทรศัพท์:',
        km: 'ก.ม.'
    },
    error_connect: {
        message: 'ไม่สามารถเชื่อมต่ออินเทอร์เน็ตได้ <br/> กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ตของคุณ <br/> แล้วลองใหม่อีกครั้ง',
        btn_close: 'ปิด'

    },

    error_empty: {
        message: "ข้อมูลไม่สมบูรณ์ กรุณาติดต่อแผนกบริการลูกค้าโทร 02-7161-815 (จ.-ศ. เวลา 9:00-16:00)"
    },

    cancel_membership: {
        message: 'กรุณาติดต่อศูนย์บริการลูกค้า',
        phone: 'โทร: (+66) 02-666-9462',
        email: 'Email: contact@dior.co.th'
    },
    contact_us: {
        title: 'รายละเอียดสำหรับการติดต่อฝ่ายบริการลูกค้า',
        hotlineLabel: 'เบอร์โทรติดต่อ',
        emailLabel: 'อีเมล',
        onlineContactLabel: 'แบบฟอร์มติดต่อสอบถาม',
        hoursLabel: 'เวลา',
        hotline: '(+66) 02-666-9462',
        email: ' contact@dior.co.th',
        onlineContact: 'https://shop.dior.co.th/pages/contact-us',
        hours: '10:00 – 12:00; 14:00 – 18:00',
        days: 'วันจันทร์ - ศุกร์ ยกเว้นวันเสาร์ อาทิตย์และวันหยุดนักขัตฤกษ์'
    }
};
